import Vue from "vue";
import Vuex from "vuex";
import {
  auth,
  basic,
  cuti,
  notification,
  publik,
  menus,
  master,
  bank,
  phoneCodes,
  karyawan,
  statusKaryawan,
  notif,
  alokasiManager,
  bebanCostCenter,
  administrator,
  layoutNonScroll,
  exports,
  env
} from "./modules/index";
import * as socketio from "../plugins/socketio";
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    basic,
    cuti,
    notification,
    publik,
    menus,
    master,
    bank,
    phoneCodes,
    karyawan,
    statusKaryawan,
    notif,
    alokasiManager,
    bebanCostCenter,
    administrator,
    layoutNonScroll,
    exports,
    env
  },
  state: {
    specialMenu: {},
    id_menu: ""
  },
  getters: {},
  mutations: {},
  actions: {
    SEND_EVENT({}, event) {
      socketio.sendEvent(event);
    }
  }
});
